import { useEffect, useState } from "react";
import useLocation from "./useLocation";

export default function useURLSearchParams(){
    const [params, _setParams] = useState({});

    const location = useLocation();

    useEffect(()=>{
        // based on: https://stackoverflow.com/a/901144
        const p = new Proxy(new URLSearchParams(location.search), {
            get: (searchParams, prop) => searchParams[prop] || searchParams.get(prop),
        });
        _setParams(p);

    },[location]);

    function setParams(newVal){
        if(typeof newVal == 'function'){
            const res = newVal(params);
            updateURL(res);
        }else{
            updateURL(newVal);
        }
    }
    function updateURL(newParams){
        const {origin, pathname} = location;
        const newUrl = origin + pathname + new URLSearchParams(newParams);
        // window.location.replace(newUrl);
        history.replaceState({}, document.title, newUrl);
    }

    // Get the value of "some_key" in eg "https://example.com/?some_key=some_value"
    // let value = params.some_key; // "some_value"
    return [params, setParams];
}